'use strict';

angular.module('myConsultApp')
    .factory('InvitationService', function ($resource, ENV, Session) {

        var invitationService = {};
        
        var email = '';

        invitationService.storeEmail = function (value) {
						email = value;
            return email;
        };
        
        invitationService.getEmail = function () {
            return email;
        };
        
        return invitationService;
  });